/* eslint-disable  */
import { Favorite, ShoppingCart } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useHistory, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { bindActionCreators } from "redux";
import {
  productActionCreators,
  userDataActionCreators,
} from "../../../../service/action-creators";
import { GetUserProfile } from "../../../../service/action-creators/authAction";
import { GetNotifications } from "../../../../service/action-creators/notificationAction";
import Loader from "../../../Loader";
import RenderHome from "../../home/RenderHome";

function ProductDetailed() {
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    AddFavoriteProducts,
    AddProductToCart,
    ResetUserDataResponse,
    GetCartProducts,
  } = bindActionCreators(userDataActionCreators, dispatch);
  const { ResetProductResponse, GetProductDetailed } = bindActionCreators(
    productActionCreators,
    dispatch
  );

  const user = useSelector((state) => state?.user);
  const carts = user?.cart;
  const productData = useSelector((state) => state?.product);
  const { isLoading, product_detailed } = productData;

  const product_id = new URLSearchParams(useLocation()?.search).get(
    "product_id"
  );
  const product = location?.state?.product;
  const favProducts = user.favoriteProducts;
  const favProductIds = [];
  favProducts.map((fav) => favProductIds.push(fav?.product_id?._id));

  const [selectedSize, setSelectedSize] = useState({
    size: "",
    index: null,
  });
  const [selectedColor, setSelectedColor] = useState({
    color: "",
    index: null,
  });
  const [quantity, setQuantity] = useState(1);
  const [changedPrice, setChangedPrice] = useState(null);
  const [changedOldPrice, setChangedOldPrice] = useState(null);
  const [selectedPeriod, setSelectedPeriod] = useState(3);

  useEffect(() => {
    if (carts?.length > 0) {
      let selectedDuration;
      let percentChange;

      // if (Number(carts[0]?.period) === 24) {
      //   percentChange = 1.2;
      //   selectedDuration = Number(carts[0]?.period);
      // } else
      //
      if (Number(carts[0]?.period) === 18) {
        percentChange = 1.145;
        selectedDuration = Number(carts[0]?.period);
      } else if (
        Number(carts[0]?.period) === 3 ||
        Number(carts[0]?.period) === 6 ||
        Number(carts[0]?.period) === 12
      ) {
        percentChange = 1.1;
        selectedDuration = Number(carts[0]?.period);
      }

      const adminCharge = 3 / 100;
      const retailPrice = Number(product?.new_price);
      const adminAmount = retailPrice * adminCharge;
      const initialAmount = retailPrice * percentChange + adminAmount;

      setChangedPrice(Number(initialAmount / selectedDuration).toFixed(2));

      // OLD PRICE
      const retailOldPrice = Number(product?.old_price);
      const adminOldAmount = retailOldPrice * adminCharge;
      const initialOldAmount = retailOldPrice * percentChange + adminOldAmount;

      setChangedOldPrice(
        Number(initialOldAmount / selectedDuration).toFixed(2)
      );
    } else {
      const defaultDuration = 3;
      const percentChange = 1.1;
      const adminCharge = 3 / 100;
      const retailPrice = Number(product?.new_price);
      const adminAmount = retailPrice * adminCharge;
      const initialAmount = retailPrice * percentChange + adminAmount;

      setChangedPrice(Number(initialAmount / defaultDuration).toFixed(2));

      // OLD PRICE
      const retailOldPrice = Number(product?.old_price);
      const adminOldAmount = retailOldPrice * adminCharge;
      const initialOldAmount = retailOldPrice * percentChange + adminOldAmount;

      setChangedOldPrice(Number(initialOldAmount / defaultDuration).toFixed(2));
    }
  }, [carts]);
  // Function to check if user can place a new order
  const canPlaceOrder = () => {
    // Check localStorage first
    const storedOrderData = localStorage.getItem("userOrderStatus");
    if (storedOrderData) {
      const orderData = JSON.parse(storedOrderData);
      if (orderData.hasActiveOrders) {
        return {
          canApply: false,
          message:
            orderData.message ||
            "You have active orders. Please wait for them to complete.",
        };
      }
    }

    // Check Redux state
    if (!user?.orders || user.orders.length === 0) {
      localStorage.setItem(
        "userOrderStatus",
        JSON.stringify({
          hasActiveOrders: false,
          lastChecked: new Date().toISOString(),
        })
      );
      return { canApply: true, message: "" };
    }

    const restrictiveOrder = user.orders.find((order) => {
      return order.status !== "rejected" && order.status !== "shipped";
    });

    if (restrictiveOrder) {
      let message = `You already have an order with status: ${restrictiveOrder.status}. Please wait for it to complete.`;

      localStorage.setItem(
        "userOrderStatus",
        JSON.stringify({
          hasActiveOrders: true,
          message: message,
          lastChecked: new Date().toISOString(),
          restrictiveOrderId: restrictiveOrder._id,
        })
      );

      return {
        canApply: false,
        message: message,
      };
    }

    localStorage.setItem(
      "userOrderStatus",
      JSON.stringify({
        hasActiveOrders: false,
        lastChecked: new Date().toISOString(),
      })
    );
    return { canApply: true, message: "" };
  };

  const handleAddToCart = (e) => {
    e.preventDefault();
    const payload = {
      size: selectedSize?.size,
      color: selectedColor?.color,
      quantity: quantity,
      product_id: product?._id,
      period: carts.length > 0 ? Number(carts[0].period) : selectedPeriod,
      period_price: changedPrice,
    };

    AddProductToCart(payload);

    const orderCheck = canPlaceOrder();

    if (orderCheck.canApply) {
    } else {
      setLoanRestrictionMessage(orderCheck.message);
      setOpenLoanRestriction(true);
    }
  };

  const handlePriceChange = (e) => {
    let adminCharge = 3 / 100;
    let value = null;
    if (e.target) {
      value = e.target.value;
      setSelectedPeriod(e.target.value);
    }
    let percentChange = 1.1;

    // if (Number(e.target.value) === 24) {
    //   percentChange = 1.2;
    // } else
    //

    if (Number(e.target.value) === 18) {
      percentChange = 1.145;
    } else if (
      Number(e.target.value) === 3 ||
      Number(e.target.value) === 6 ||
      Number(e.target.value) === 12
    ) {
      percentChange = 1.1;
    }

    const retailPrice = Number(product?.new_price);
    const adminAmount = retailPrice * adminCharge;
    const initialAmount = retailPrice * percentChange + adminAmount;

    setChangedPrice(Number(initialAmount / e.target.value).toFixed(2));

    // OLD PRICE
    const retailOldPrice = Number(product?.old_price);
    const adminOldAmount = retailOldPrice * adminCharge;
    const initialOldAmount = retailOldPrice * percentChange + adminOldAmount;

    setChangedOldPrice(Number(initialOldAmount / e.target.value).toFixed(2));
  };

  useEffect(() => {
    GetCartProducts();
    dispatch(GetUserProfile());
    dispatch(GetNotifications());
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (
      user?.response?.state === "SUCCESS" ||
      productData?.response?.state === "SUCCESS"
    ) {
      toast.success(productData?.response?.message);
      GetCartProducts();
      setTimeout(() => {
        ResetUserDataResponse();
        ResetProductResponse();
      }, 1500);
    } else if (
      user?.response?.state === "ERROR" ||
      productData?.response?.state === "ERROR"
    ) {
      toast.error(productData?.response?.message);
      setTimeout(() => {
        ResetUserDataResponse();
        ResetProductResponse();
      }, 1500);
    }
  }, [user?.response?.state || productData.response.state]);

  return (
    <div className="ProductDetailed">
      <RenderHome>
        <button
          className="mb-6 px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded-lg transition-colors duration-200"
          onClick={() => history.goBack()}
        >
          ← Back
        </button>

        {user?.isLoading || (isLoading && <Loader />)}

        <div className="flex flex-col lg:flex-row gap-8">
          {/* Image Section */}
          <div className="w-full lg:w-1/2">
            <div className="bg-white rounded-xl shadow-md overflow-hidden">
              <Carousel
                autoPlay={false}
                infiniteLoop
                labels={false}
                showIndicators={false}
                showThumbs={true}
                showStatus={false}
                className="slider"
              >
                {product?.images?.map((img, index) => (
                  <div className="aspect-square" key={index}>
                    <img
                      src={img?.url}
                      alt="product"
                      className="w-full h-full object-contain"
                    />
                  </div>
                ))}
              </Carousel>
            </div>
          </div>

          {/* Product Info Section */}
          <div className="w-full lg:w-1/2">
            <div className="bg-white p-6 rounded-xl shadow-md">
              <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
                {product?.product_name}
              </h1>

              <div className="flex items-center mb-4">
                {product?.quantity > 0 ? (
                  <span className="px-2 py-1 bg-green-100 text-green-800 text-xs font-medium rounded">
                    In Stock
                  </span>
                ) : (
                  <span className="px-2 py-1 bg-red-100 text-red-800 text-xs font-medium rounded">
                    Out of Stock
                  </span>
                )}
              </div>

              <div className="mb-6">
                <div className="flex items-center gap-4">
                  <div className="text-3xl font-bold text-gray-900">
                    &#8373;{changedPrice}{" "}
                    <span className="text-sm font-normal">/month</span>
                  </div>
                  {changedOldPrice && (
                    <div className="text-lg text-gray-500 line-through">
                      &#8373;{changedOldPrice}
                    </div>
                  )}
                </div>

                <div className="mt-2">
                  <select
                    onChange={handlePriceChange}
                    className="w-full md:w-auto px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  >
                    {carts.length > 0 ? (
                      <option value={carts[0]?.period}>
                        {carts[0]?.period} months
                      </option>
                    ) : (
                      <>
                        <option value={3}>3 months</option>
                        <option value={6}>6 months</option>
                        <option value={12}>12 months</option>
                        <option value={18}>18 months</option>
                        {/* <option value={24}>24 months</option> */}
                      </>
                    )}
                  </select>
                </div>
              </div>

              {/* Size Selection */}
              {product?.sizes?.length > 0 && (
                <div className="mb-6">
                  <h3 className="text-sm font-medium text-gray-900 mb-2">
                    Size
                  </h3>
                  <div className="flex flex-wrap gap-2">
                    {product?.sizes?.map((size, index) => (
                      <button
                        key={index}
                        onClick={() =>
                          setSelectedSize({
                            ...selectedSize,
                            size: size,
                            index: index,
                          })
                        }
                        className={`px-4 py-2 border rounded-md ${
                          index === selectedSize?.index
                            ? "border-blue-500 bg-blue-50 text-blue-700"
                            : "border-gray-300 hover:bg-gray-50"
                        }`}
                      >
                        {size}
                      </button>
                    ))}
                  </div>
                </div>
              )}

              {/* Color Selection */}
              {product?.colors?.length > 0 && (
                <div className="mb-6">
                  <h3 className="text-sm font-medium text-gray-900 mb-2">
                    Color
                  </h3>
                  <div className="flex flex-wrap gap-2">
                    {product?.colors?.map((color, index) => (
                      <button
                        key={index}
                        onClick={() =>
                          setSelectedColor({
                            ...selectedColor,
                            color: color,
                            index: index,
                          })
                        }
                        className={`px-4 py-2 border rounded-md ${
                          index === selectedColor?.index
                            ? "border-blue-500 bg-blue-50 text-blue-700"
                            : "border-gray-300 hover:bg-gray-50"
                        }`}
                      >
                        {color}
                      </button>
                    ))}
                  </div>
                </div>
              )}

              {/* Quantity */}
              <div className="mb-8">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Quantity
                </label>
                <input
                  type="number"
                  min="1"
                  defaultValue="1"
                  onChange={(e) => setQuantity(e?.target?.value)}
                  className="w-24 px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              {/* Action Buttons */}
              <div className="flex flex-col sm:flex-row gap-4">
                <button
                  className={`flex-1 flex items-center justify-center gap-2 px-6 py-3 rounded-lg ${
                    favProductIds?.includes(product?._id)
                      ? "bg-red-100 text-red-700 hover:bg-red-200"
                      : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                  } transition-colors duration-200`}
                  onClick={(e) => {
                    AddFavoriteProducts(product?._id);
                  }}
                >
                  <Favorite
                    style={{
                      color: favProductIds?.includes(product?._id)
                        ? "red"
                        : "gray",
                    }}
                  />
                  {favProductIds?.includes(product?._id) ? "Saved" : "Save"}
                </button>

                <button
                  className="flex-1 flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors duration-200"
                  onClick={(e) => handleAddToCart(e)}
                  disabled={!canPlaceOrder().canApply}
                >
                  <ShoppingCart />
                  Add to Cart
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Product Description */}
        <div className="mt-12 bg-white p-6 rounded-xl shadow-md">
          <h2 className="text-xl font-bold text-gray-900 mb-4">
            Product Details
          </h2>
          <div
            className="prose max-w-none"
            dangerouslySetInnerHTML={{ __html: product?.description }}
          />
        </div>

        {/* Additional Images */}
        {product?.images?.length > 1 && (
          <div className="mt-12">
            <h2 className="text-xl font-bold text-gray-900 mb-6">
              More Images
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              {product?.images?.map((img, index) => (
                <div
                  key={index}
                  className="aspect-square bg-gray-100 rounded-lg overflow-hidden"
                >
                  <img
                    src={img?.url}
                    alt={`Product view ${index + 1}`}
                    className="w-full h-full object-cover"
                  />
                </div>
              ))}
            </div>
          </div>
        )}

        <ToastContainer autoClose={3000} />
      </RenderHome>
    </div>
  );
}

export default ProductDetailed;
